export default class StudentLoan {
    constructor(studentLoan) {
        this.rate = studentLoan.rate;
        this.thresholds = studentLoan.thresholds;
    }

    getThreshold(studentLoanType) {
        return this.thresholds[studentLoanType];
    }
}